export function fetchResponse(url, method, body) {
    const requestOptions = {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: method !== 'GET' ? JSON.stringify(body) : null
    };
    return fetch(url, requestOptions)
        .then(response => response.json())
        .then(validateData)
        .catch((error) => {
            throw  error
        });
}

const validateData = (data) => {
    if (data.redirectUrl && data.ulAction == '/signin') {
        throw 'SESSION_EXPIRED';
    }
    return data;
}

export const validateAuth = (error) => {
    if (error === 'SESSION_EXPIRED') {
        location.reload();
        return;
    }
    return true
}

export function postMulitPartData(url, method, body){
    const requestOptions = {
        method: method,
        body: body
    };

    return fetch(url, requestOptions)
        .then((response) => response.json())
        .then(data => data)
        .catch(function (error) {
            throw  error
        });
}